export const DATA_TEST_IDS = {
  WRAPPER: 'apiError__wrapper'
};
